import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const LoadingScreen = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <CircularProgress size={60} color="primary" />
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ mt: 2 }}
      >
        EngliX Yükleniyor...
      </Typography>
    </Box>
  )
}

export default LoadingScreen
